<template>
  <div class="defect-image-tab">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-select
        v-model="searchForm.vehicleId"
        placeholder="请选择车辆"
        style="width: 200px; margin-right: 10px"
        clearable
        filterable
        @change="handleSearchVehicleChange"
      >
        <el-option label="全局" value="" />
        <el-option
          v-for="vehicle in vehicleList"
          :key="vehicle.vehicleId"
          :label="getVehicleDisplayName(vehicle)"
          :value="vehicle.vehicleId"
        />
      </el-select>
      <el-select
        v-model="searchForm.itemId"
        placeholder="请选择检测项目"
        style="width: 200px; margin-right: 10px"
        clearable
        filterable
        :disabled="searchForm.vehicleId === ''"
      >
        <el-option
          v-for="item in filteredSearchInspectionItemOptions"
          :key="item.id"
          :label="getInspectionItemDisplayName(item)"
          :value="item.itemId"
        />
      </el-select>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button @click="handleReset">重置</el-button>
      <el-button type="success" @click="handleAdd">新增</el-button>
    </div>
    
    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%; margin-top: 20px">
      <el-table-column prop="imageId" label="图片ID" width="150" />
      <el-table-column prop="itemId" label="检测项目" width="200">
        <template slot-scope="scope">
          {{ getInspectionItemName(scope.row.itemId) }}
        </template>
      </el-table-column>
      <el-table-column prop="vehicleId" label="车辆ID" width="150" />
      <el-table-column prop="imageUrl" label="图片" width="120">
        <template slot-scope="scope">
          <el-button v-if="scope.row.imageUrl" size="mini" type="text" @click="previewImage(scope.row.imageUrl)">
            查看图片
          </el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="imageTitle" label="图片标题" width="150" />
      <el-table-column prop="imageDescription" label="图片描述" show-overflow-tooltip />
      <el-table-column prop="defectDescription" label="瑕疵说明" show-overflow-tooltip />
      <el-table-column prop="sortOrder" label="排序" width="80" />
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.current"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      style="margin-top: 20px; text-align: right"
    />
    
    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="车辆" prop="vehicleId">
          <el-select v-model="form.vehicleId" placeholder="请选择车辆" style="width: 100%" @change="handleVehicleChange">
            <el-option
              v-for="vehicle in vehicleList"
              :key="vehicle.vehicleId"
              :label="getVehicleDisplayName(vehicle)"
              :value="vehicle.vehicleId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="检测项目" prop="itemId">
          <el-select v-model="form.itemId" placeholder="请选择检测项目" style="width: 100%" :disabled="!form.vehicleId">
            <el-option
              v-for="item in filteredInspectionItemOptions"
              :key="item.id"
              :label="getInspectionItemDisplayName(item)"
              :value="item.itemId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="图片地址" prop="imageUrl">
          <div class="upload-container">
            <el-upload
              class="image-upload"
              action=""
              :http-request="handleImageUpload"
              :show-file-list="false"
              :before-upload="beforeImageUpload"
              accept="image/*"
            >
              <div class="upload-area">
                <div v-if="!form.imageUrl" class="upload-placeholder">
                  <i class="el-icon-plus"></i>
                  <div class="upload-text">点击上传图片</div>
                </div>
                <img v-else :src="form.imageUrl" class="uploaded-image" />
              </div>
            </el-upload>
            <div v-if="form.imageUrl" class="image-actions">
              <el-button size="mini" type="text" @click="previewUploadedImage">预览</el-button>
              <el-button size="mini" type="text" @click="removeUploadedImage">删除</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="图片标题" prop="imageTitle">
          <el-input v-model="form.imageTitle" placeholder="请输入图片标题" />
        </el-form-item>
        <el-form-item label="图片描述" prop="imageDescription">
          <el-input
            v-model="form.imageDescription"
            type="textarea"
            :rows="3"
            placeholder="请输入图片描述"
          />
        </el-form-item>
        <el-form-item label="瑕疵说明" prop="defectDescription">
          <el-input
            v-model="form.defectDescription"
            type="textarea"
            :rows="4"
            placeholder="请输入瑕疵说明"
          />
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0" style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDefectImageList, addDefectImage, updateDefectImage, deleteDefectImage } from '@/api/defectImage'
import { getInspectionItemOptions, getInspectionItemOptionsByVehicle } from '@/api/inspectionItem'
import { uploadImage } from '@/api/upload'
import request from '@/utils/request'

export default {
  name: 'DefectImageTab',
  data() {
    return {
      searchForm: {
        vehicleId: '',
        itemId: ''
      },
      vehicleList: [],
      inspectionItemOptions: [], // 检测项目选项列表（全局）
      filteredInspectionItemOptions: [], // 表单中过滤后的检测项目选项
      filteredSearchInspectionItemOptions: [], // 搜索栏中过滤后的检测项目选项
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增瑕疵图片',
      form: {
        vehicleId: '',
        itemId: '',
        imageUrl: '',
        imageTitle: '',
        imageDescription: '',
        defectDescription: '',
        sortOrder: 0
      },
      rules: {
        vehicleId: [
          { required: true, message: '请选择车辆', trigger: 'change' }
        ],
        itemId: [
          { required: true, message: '请选择检测项目', trigger: 'change' }
        ],
        imageUrl: [
          { required: true, message: '请输入图片地址', trigger: 'blur' }
        ],
        sortOrder: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      },
      isEdit: false,
      editId: null
    }
  },
  mounted() {
    this.loadVehicleList()
    this.loadInspectionItemOptions()
    this.loadData()
  },
  methods: {
    // 加载车辆列表
    async loadVehicleList() {
      try {
        const response = await request.get('/api/admin/guarantee/vehicle/options')
        if (response.code === '200') {
          this.vehicleList = response.data || []
        } else {
          console.error('加载车辆列表失败:', response.msg)
        }
      } catch (error) {
        console.error('加载车辆列表失败:', error)
      }
    },
    
    // 加载检测项目选项列表
    async loadInspectionItemOptions() {
      try {
        const response = await getInspectionItemOptions()
        console.log('检测项目选项API响应:', response)
        if (response.code === '200') {
          this.inspectionItemOptions = response.data || []
          // 初始化搜索栏的检测项目选项（显示所有项目）
          this.filteredSearchInspectionItemOptions = this.inspectionItemOptions
          console.log('检测项目选项数据:', this.inspectionItemOptions)
        } else {
          console.error('加载检测项目选项失败:', response.msg)
        }
      } catch (error) {
        console.error('加载检测项目选项失败:', error)
      }
    },
    
    // 获取车辆显示名称
    getVehicleDisplayName(vehicle) {
      return `${vehicle.brand} ${vehicle.model} (${vehicle.vehicleId})`
    },
    
    // 获取检测项目名称
    getInspectionItemName(itemId) {
      const item = this.inspectionItemOptions.find(option => option.itemId === itemId)
      return item ? item.name : itemId
    },
    
    // 获取检测项目显示名称（包含项目ID信息）
    getInspectionItemDisplayName(item) {
      return `${item.name} (${item.itemId})`
    },
    
    // 加载数据
    async loadData() {
      try {
        const params = {
          current: this.pagination.current,
          size: this.pagination.size,
          vehicleId: this.searchForm.vehicleId,
          itemId: this.searchForm.itemId
        }
        const response = await getDefectImageList(params)
        if (response.code === '200') {
          this.tableData = response.data.records
          this.pagination.total = response.data.total
        } else {
          this.$message.error(response.msg || '获取数据失败')
        }
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('网络错误，请重试')
      }
    },
    
    // 搜索
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    
    // 重置
    handleReset() {
      this.searchForm.vehicleId = ''
      this.searchForm.itemId = ''
      this.pagination.current = 1
      this.loadData()
    },
    
    // 新增
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增瑕疵图片'
      this.form = {
        vehicleId: '',
        itemId: '',
        imageUrl: '',
        imageTitle: '',
        imageDescription: '',
        defectDescription: '',
        sortOrder: 0
      }
      this.filteredInspectionItemOptions = [] // 重置过滤的检测项目选项
      this.dialogVisible = true
    },
    
    // 处理表单中的车辆变更
    async handleVehicleChange(vehicleId) {
      // 清空检测项目选择
      this.form.itemId = ''
      
      if (vehicleId) {
        try {
          const response = await getInspectionItemOptionsByVehicle(vehicleId)
          if (response.code === '200') {
            this.filteredInspectionItemOptions = response.data || []
          } else {
            this.filteredInspectionItemOptions = []
            console.error('加载车辆检测项目选项失败:', response.msg)
          }
        } catch (error) {
          this.filteredInspectionItemOptions = []
          console.error('加载车辆检测项目选项失败:', error)
        }
      } else {
        this.filteredInspectionItemOptions = []
      }
    },
    
    // 处理搜索栏中的车辆变更
    async handleSearchVehicleChange(vehicleId) {
      // 清空检测项目搜索选择
      this.searchForm.itemId = ''
      
      if (vehicleId && vehicleId !== '') {
        try {
          const response = await getInspectionItemOptionsByVehicle(vehicleId)
          if (response.code === '200') {
            this.filteredSearchInspectionItemOptions = response.data || []
          } else {
            this.filteredSearchInspectionItemOptions = []
            console.error('加载车辆检测项目选项失败:', response.msg)
          }
        } catch (error) {
          this.filteredSearchInspectionItemOptions = []
          console.error('加载车辆检测项目选项失败:', error)
        }
      } else {
        // 如果选择"全局"，显示所有检测项目
        this.filteredSearchInspectionItemOptions = this.inspectionItemOptions
      }
    },
    
    // 编辑
    async handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.dialogTitle = '编辑瑕疵图片'
      this.form = { ...row }
      
      // 如果有车辆ID，加载对应的检测项目选项
      if (row.vehicleId) {
        try {
          const response = await getInspectionItemOptionsByVehicle(row.vehicleId)
          if (response.code === '200') {
            this.filteredInspectionItemOptions = response.data || []
          } else {
            this.filteredInspectionItemOptions = []
          }
        } catch (error) {
          this.filteredInspectionItemOptions = []
        }
      } else {
        this.filteredInspectionItemOptions = []
      }
      
      this.dialogVisible = true
    },
    
    // 删除
    handleDelete(row) {
      this.$confirm('确认删除该瑕疵图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await deleteDefectImage(row.id)
          if (response.code === '200') {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(response.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('网络错误，请重试')
        }
      })
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let response
            if (this.isEdit) {
              response = await updateDefectImage(this.form)
            } else {
              response = await addDefectImage(this.form)
            }
            
            if (response.code === '200') {
              this.$message.success(this.isEdit ? '更新成功' : '添加成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(response.msg || (this.isEdit ? '更新失败' : '添加失败'))
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$message.error('网络错误，请重试')
          }
        }
      })
    },
    
    // 预览图片
    previewImage(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },

    // 预览上传的图片
    previewUploadedImage() {
      if (this.form.imageUrl) {
        window.open(this.form.imageUrl, '_blank')
      }
    },

    // 移除上传的图片
    removeUploadedImage() {
      this.form.imageUrl = ''
    },

    // 图片上传前的钩子
    beforeImageUpload(rawFile) {
      const isJPG = rawFile.type === 'image/jpeg' || rawFile.type === 'image/png' || rawFile.type === 'image/gif'
      const isLt2M = rawFile.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('图片只能是 JPG/PNG/GIF 格式!')
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },

    // 处理图片上传
    async handleImageUpload(options) {
      try {
        const response = await uploadImage(options.file)
        if (response.code === '200') {
          this.form.imageUrl = response.data
          this.$message.success('图片上传成功')
        } else {
          this.$message.error(response.msg || '图片上传失败')
        }
      } catch (error) {
        console.error('图片上传失败:', error)
        this.$message.error('图片上传失败')
      }
    },
    
    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.size = size
      this.loadData()
    },
    
    // 当前页改变
    handleCurrentChange(current) {
      this.pagination.current = current
      this.loadData()
    }
  }
}
</script>

<style scoped>
.defect-image-tab {
  padding: 20px;
}

.search-bar {
  margin-bottom: 20px;
}

.upload-container {
  position: relative;
  display: inline-block;
  width: 100px; /* Adjust as needed */
  height: 100px; /* Adjust as needed */
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  background-color: #f5f7fa;
  text-align: center;
  line-height: 100px;
  cursor: pointer;
}

.image-upload {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-area {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-placeholder {
  color: #909399;
  font-size: 14px;
}

.upload-text {
  margin-top: 5px;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 0 4px 0 4px;
  padding: 2px 5px;
  display: flex;
  gap: 5px;
  z-index: 10;
}

.image-actions .el-button {
  color: #fff;
  font-size: 12px;
}
</style> 